import React from "react";
import { Box, Typography } from "@mui/material";

const DiscountTimer = ({ endDateStr }) => {
  const [timeLeft, setTimeLeft] = React.useState("");

  React.useEffect(() => {
    if (!endDateStr) return;

    // Convert "2026-10-08 07:46:17" to "2026-10-08T07:46:17" for strict Safari/iOS parsing
    const target = new Date(endDateStr.replace(" ", "T")).getTime();

    const updateTimer = () => {
      const now = new Date().getTime();
      const distance = target - now;

      if (distance <= 0) {
        setTimeLeft("منقضی شده");
        return;
      }

      const days = Math.floor(distance / (1000 * 60 * 60 * 24));
      const hours = Math.floor(
        (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60),
      );
      const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((distance % (1000 * 60)) / 1000);

      const formattedTime = `${String(hours).padStart(2, "0")}:${String(minutes).padStart(2, "0")}:${String(seconds).padStart(2, "0")}`;
      setTimeLeft(days > 0 ? `${days} روز و ${formattedTime}` : formattedTime);
    };

    updateTimer();
    const interval = setInterval(updateTimer, 1000);
    return () => clearInterval(interval);
  }, [endDateStr]);

  if (!timeLeft) return null;

  return (
    <Box
      display="flex"
      alignItems="center"
      gap={1}
      mt={0.5}
      sx={{ color: "error.main" }}
    >
      <Typography variant="body2" fontWeight={800} dir="ltr">
        {timeLeft}
      </Typography>
      <Typography variant="caption" fontWeight={700}>
        تا پایان تخفیف
      </Typography>
    </Box>
  );
};

export default DiscountTimer;
